import { render, staticRenderFns } from "./5radio.vue?vue&type=template&id=efe6f360"
import script from "./5radio.vue?vue&type=script&lang=js"
export * from "./5radio.vue?vue&type=script&lang=js"
import style0 from "./5radio.vue?vue&type=style&index=0&id=efe6f360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports